export default __webpack_public_path__ + "static/media/announcement_bg.bd638dfa.png";